import { Component, Input, OnInit } from '@angular/core';
import { Terminal } from 'src/app/@core/domain/interfaces/terminal.interface';

/**
 * Status led for terminal icons used in terminal overlays
 */
@Component({
  selector: 'app-status-led',
  templateUrl: './status-led.component.html',
  styleUrls: ['./status-led.component.scss'],
})
export class StatusLedComponent implements OnInit {
  @Input()
  terminal!: Terminal;
  terminalTypeIcon!: any;

  constructor() {}

  ngOnInit(): void {
    const terminalTypeEnumValue = Object.values(this.terminal.type)[0];
    this.terminalTypeIcon = 'terminalType_' + terminalTypeEnumValue;
  }
}
